import React, { Component } from 'react';
import {Link}from 'react-router-dom';

// images

import imageSupplier01 from './Logos_Lieferanten/demmeler.png';
import imageSupplier03 from './Logos_Lieferanten/davi.png';
import imageSupplier04 from './Logos_Lieferanten/loewer.png';
import imageSupplier05 from './Logos_Lieferanten/carif.png';
import imageSupplier06 from '../images/Logos_Lieferanten/almi.png';
import imageSupplier07 from '../images/Logos_Lieferanten/aalbersfarina.png';
import imageSupplier08 from '../images/Logos_Lieferanten/jara.png';
import imageSupplier09 from '../images/Logos_Lieferanten/bodor.png';



import {Grid, Row, Col, Breadcrumb} from 'react-bootstrap';

class SuB extends Component {
  render() {
    return (
      <div className='container-fluid'>
        <div className="BCMain">
          <Breadcrumb className='breadcrumb-item'>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item >
              <Link to="/Suppliers">Übersicht</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Stahl- und Blechbearbeitung</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <br/>

        <Grid>

          {/* Demmeler */}

          <Row className="show-grid">
            <Col xs={12}  sm={3}>
                <Link to="/Suppliers/Demmeler"><img className="supplierImagesOverview"  src={imageSupplier01} alt="..." width="100%"/></Link>
            </Col>
            <Col xsHidden  sm={9} className="supplierOverviewDesc">
              <Link to="/Suppliers/Demmeler">
              <h3>3D-Schweißtische und Manipulatoren  „Das Original“</h3>
              <h4 className="verticalAlign">Mit dem Universal 3D Arbeits- und Schweißtisch können sowohl im horizontalen als auch im vertikalen Bereich alle Anforderungen erfüllt werden. Exakt, schnell und im Handumdrehen bauen Sie mit diesem modularen Baukastensystem Ihre Teile auf: Maschinengehäuse, Gestelle, Rahmen, Traversen, Konsolen, Geländer, Treppen, Tore, Schaltschränke, Blechverkleidungen u.v.m. </h4>
            </Link>
            </Col>
            <Col xs={12}  smHidden mdHidden lgHidden className="supplierOverviewDesc">
              <Link to="/Suppliers/Demmeler">
              <h4 className="verticalAlign">3D-Schweißtische und Manipulatoren  „Das Original“ </h4>
            </Link>
            </Col>
          </Row>
          <hr/>

          
          {/* Bodor */}

          <Row className="show-grid">
          <Col xs={12}  sm={3}>
              <Link to="/Suppliers/Bodor"><img className="supplierImagesOverview"  src={imageSupplier09} alt="Bodor Logo" width="100%"/></Link>
          </Col>
          <Col xsHidden  sm={9} className="supplierOverviewDesc">
            <Link to="/Suppliers/Bodor">
            <h3>Bodor Laser – Präzision in Lichtgeschwindigkeit</h3>
            <h4 className="verticalAlign">Bodor Laserschneidanlagen vereinen modernste Faserlasertechnologie mit hoher Schnittgeschwindigkeit, Präzision und automatisierten Funktionen für eine effiziente und sichere Metallbearbeitung in der Industrie.

          </h4>
          </Link>
          </Col>
          <Col xs={12}  smHidden mdHidden lgHidden className="supplierOverviewDesc">
            <Link to="/Suppliers/Bodor">
            <h4 className="verticalAlign">Bodor Laser – Präzision in Lichtgeschwindigkeit</h4>
          </Link>
          </Col>
          </Row>
          
            {/* DAVI */}

          <Row className="show-grid">
            <Col xs={12}  sm={3}>
                <Link to="/Suppliers/DAVI"><img className="supplierImagesOverview"  src={imageSupplier03} alt="..." width="100%"/></Link>
            </Col>
            <Col xsHidden  sm={9} className="supplierOverviewDesc">
              <Link to="/Suppliers/DAVI">
              <h3>Rund- und Profilbiegemaschinen vom Marktführer</h3>
              <h4 className="verticalAlign">DAVI-PROMAU ist der weltweit größte Hersteller von Rund- und Profilbiegemaschinen. Im Bereich Forschung, Entwicklung und Innovation  übernimmt DAVI die Führung im Sektor Rundbiege- und Profilbiegemaschinen.</h4>
            </Link>
            </Col>
            <Col xs={12}  smHidden mdHidden lgHidden className="supplierOverviewDesc">
              <Link to="/Suppliers/DAVI">
              <h4 className="verticalAlign">Rund- und Profilbiegemaschinen vom Marktführer</h4>
            </Link>
            </Col>
          </Row>
          <hr/>

            {/* LOEWER */}

          <Row className="show-grid">
            <Col xs={12}  sm={3}>
                <Link to="/Suppliers/LOEWER"><img className="supplierImagesOverview"  src={imageSupplier04} alt="..." width="100%"/></Link>
            </Col>
            <Col xsHidden  sm={9} className="supplierOverviewDesc">
              <Link to="/Suppliers/LOEWER">
              <h3>Innovative Bürst- und Bandschleifmaschinen</h3>
              <h4 className="verticalAlign">Innovative Bürst- und Bandschleifmaschinen zum Lösen spezieller Schleifaufgaben. Die Anwendungsschwerpunkte liegen dabei beim Finishschliff und beim Entgraten flächiger Werkstücke. Insbesondere die Entgratschleifmaschinen im Durchlaufverfahren für den Naß- oder Trockenschliff zeugen von preisbewußter Qualität - made in Germany.</h4>
            </Link>
            </Col>
            <Col xs={12}  smHidden mdHidden lgHidden className="supplierOverviewDesc">
              <Link to="/Suppliers/LOEWER">
              <h4 className="verticalAlign">Innovative Bürst- und Bandschleifmaschinen</h4>
            </Link>
            </Col>
          </Row>

          <hr/>
          <Row className="show-grid">
            <Col xs={12}  sm={3}>
                <Link to="/Suppliers/Carif"><img className="supplierImagesOverview"  src={imageSupplier05} alt="Logo Carif" width="100%"/></Link>
            </Col>
            <Col xsHidden  sm={9} className="supplierOverviewDesc">
              <Link to="/Suppliers/Carif">
              <h3>Halb- und Vollautomatische Bandsägen</h3>
              <h4 className="verticalAlign">Carif entwickelt und produziert mit eigener mechanischer Bearbeitung, Oberflächenbeschichtung, Elektromontage und Qualitätskontrolle. Carif ist ein moderner, flexibler, globaler Player und exportiert seine Produkte in die ganze Welt.</h4>
            </Link>
            </Col>
            <Col xs={12}  smHidden mdHidden lgHidden className="supplierOverviewDesc">
              <Link to="/Suppliers/Carif">
              <h4 className="verticalAlign">Halb- und Vollautomatische Bandsägen</h4>
            </Link>
            </Col>
          </Row>
          <hr/>

          <hr/>
          <Row className="show-grid">
            <Col xs={12}  sm={3}>
                <Link to="/Suppliers/aalbersfarina"><img className="supplierImagesOverview"  src={imageSupplier07} alt="Logo Carif" width="100%"/></Link>
            </Col>
            <Col xsHidden  sm={9} className="supplierOverviewDesc">
              <Link to="/Suppliers/aalbersfarina">
              <h3>Moderne Lagersysteme zur Blech und Langgutlagerung</h3>
              <h4 className="verticalAlign">Durch das intelligente Desing mit Schubladen kann die Lagerkapazität im Vergleich zu konventionellen Lösungen um 50% erhöht werden.</h4>
            </Link>
            </Col>
            <Col xs={12}  smHidden mdHidden lgHidden className="supplierOverviewDesc">
              <Link to="/Suppliers/aalbersfarina">
              <h4 className="verticalAlign">moderne Lagersysteme zur Blech und Langgutlagerung</h4>
            </Link>
            </Col>
          </Row>
          <hr/>

            {/* ALMI */}

          <Row className="show-grid">
            <Col xs={12}  sm={3}>
                <Link to="/Suppliers/Almi"><img className="supplierImagesOverview"  src={imageSupplier06} alt="Almi Logo" width="100%"/></Link>
            </Col>
            <Col xsHidden  sm={9} className="supplierOverviewDesc">
              <Link to="/Suppliers/Almi">
              <h3>Hochleistungs Rohrausschleifer/-klinker</h3>
              <h4 className="verticalAlign">Almi hat sich spezialisiert auf Rohrausschleifer mit hohen Geschwindigkeiten.</h4>
            </Link>
            </Col>
            <Col xs={12}  smHidden mdHidden lgHidden className="supplierOverviewDesc">
              <Link to="/Suppliers/Almi">
              <h4 className="verticalAlign">Hochleistungs Rohrausschleifer/-klinker</h4>
            </Link>
            </Col>
          </Row>
          <hr/>

            {/* Jara */}

          <Row className="show-grid">
            <Col xs={12}  sm={3}>
                <Link to="/Suppliers/Jara"><img className="supplierImagesOverview"  src={imageSupplier08} alt="Jara Logo" width="100%"/></Link>
            </Col>
            <Col xsHidden  sm={9} className="supplierOverviewDesc">
              <Link to="/Suppliers/Jara">
              <h3>CNC-Koordinaten-Bohranlagen</h3>
              <h4 className="verticalAlign">Jara entwickelt und baut CNC-Koordinaten-Bohranlagen mit moderner Technik</h4>
            </Link>
            </Col>
            <Col xs={12}  smHidden mdHidden lgHidden className="supplierOverviewDesc">
              <Link to="/Suppliers/Jara">
              <h4 className="verticalAlign">CNC-Koordinaten-Bohranlagen</h4>
            </Link>
            </Col>
          </Row>
          <hr/>

        </Grid>
        <br/>
        <br/>

      </div>
    );
  }
}

export default SuB;



// WEBPACK FOOTER //
// ./src/components/pages/supplier/sub.js